import { product_sales_group_product } from "./product_sales_group_product";

export class product_sales_group {
    public tour_id: string = "";
    public group_name: string = "";
    public products: product_sales_group_product[] = [];
    public sales_group_display_name: string = "";
    public sales_group_display_description: string = "";
}
